<script>
	import { getContext, onMount, createEventDispatcher } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles'

	const globals = getContext('globals')
	export let fontsize = globals.fsXS
	export let titleColor = globals.selectTitle
	export let borderColor = globals.inputBorder
	export let titleBackground = globals.inputBg
	export let optionBg = globals.optionBg
	export let optionHoverColor = globals.selectHover
	export let optionCaretColor = 'red'
	export let width = '100%'
	export let value = 'select item'
	export let options
	export let ID

	//sticky value test from select values
	$: shortString = value.split(' ')[0].slice(0, 7)

	const dispatch = createEventDispatcher()
	let visible = false

	const set_visible = () => {
		visible = visible === true ? false : true
	}

	const set_title = (val) => {
		//get the original value (unsliced) from options
		let origFont
		let origFontsize

		if (ID.indexOf('selFont') > -1) {
			options.forEach((item) => {
				//font family
				if (item.indexOf(val) > -1) origFont = item
			})
		}

		if (ID.indexOf('selSize') > -1) {
			options.forEach((item) => {
				//font size
				if (item === val) origFontsize = item
			})
		}

		if (ID.indexOf('selTextFont') > -1) {
			options.forEach((item) => {
				//font family
				if (item.indexOf(val) > -1) origFont = item
			})
		}

		if (ID.indexOf('selTextSize') > -1) {
			options.forEach((item) => {
				//font size
				if (item === val) origFontsize = item
			})
		}

		const element = document.getElementById(ID)

		element.style.fontFamily = 'Lucida Sans'
		element.style.fontSize = fontsize

		dispatch('select', {
			font: origFont,
			size: origFontsize,
		})
		shortString = val.split(' ')
		shortString = shortString[0].slice(0, 7)

		set_visible(false)
	}

	onMount(() => {})
</script>

<main>
	<div class="selectionContainer" use:styles={{ titleColor, borderColor, titleBackground, width, fontsize }}>
		<div class="title" use:styles={{ fontsize }} id={ID}>{shortString}</div>

		<div
			class="caretContainer"
			use:styles={{ optionBg, optionHoverColor, optionCaretColor }}
			on:click={() => set_visible(true)}
			on:keydown={() => set_visible(true)}
		>
			<div class="caret" />
		</div>
	</div>
	{#if visible}
		<div
			use:styles={{ fontsize, optionBg, optionHoverColor, width, borderColor }}
			class="option_container"
			in:slide={{ duration: 1000 }}
			out:slide={{ duration: 1000 }}
		>
			{#each options as opt}
				<div
					class="option"
					on:click={() => set_title(opt)}
					on:keydown={() => set_title(opt)}
					use:styles={{ opt, titleColor, optionHoverColor }}
				>
					{opt}
				</div>
			{/each}
		</div>
	{/if}
</main>

<style>
	main {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		width: clamp(100px, 17vw, 250px);
	}
	.selectionContainer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 30px;
		margin-bottom: 5px;
		border: 1px solid black;
		font-size: 12px;
	}

	.title {
		width: 80%;
		padding: 5px;
	}

	.caretContainer {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20%;
		height: 100%;
		background: transparent;
		cursor: pointer;
		border-left: 1px solid black;
	}

	.caretContainer:hover {
		background-color: var(--optionCaretColor);
	}

	.caret {
		width: 0;
		height: 0;
		border-left: clamp(1px, 1vw, 10px) solid transparent;
		border-right: clamp(1px, 1vw, 10px) solid transparent;
		border-top: clamp(1px, 1vw, 10px) solid #555;
	}

	.option_container {
		padding: 10px;
		background-color: var(--optionBg);
		max-height: 200px;
		overflow-y: scroll;
		overflow-x: hidden;
		font-size: calc(var(--fontsize) - 3px);
		border-left: 1px solid var(--borderColor);
		border-right: 1px solid var(--borderColor);
		border-bottom: 1px solid var(--borderColor);
		width: 100%;
	}

	.option {
		color: var(--titleColor);
		cursor: pointer;
		padding: 10px;
		font-size: 12px;
		font-family: var(--opt);
	}

	.option:hover {
		background: var(--optionHoverColor);
	}
</style>
